// ======= Flickity slideshow =======

jQuery('.standard-carousel-sg').flickity({
	"pageDots": true,
	"prevNextButtons": false,
	"adaptiveHeight": true,
	"imagesLoaded": true
});
jQuery('.frontpage-carousel-sg').flickity({
	"pageDots": true,
	"prevNextButtons": true,
	"imagesLoaded": true
});